import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { ApiError } from './api/client.js';
import { App } from './App.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A dispatch board must not show stale state. 10 seconds is short enough
      // that a case someone else dispatched appears almost immediately, without
      // hammering the API from every open control-room terminal.
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      // A 401 means the session ended; retrying just delays the redirect to login.
      retry: (count, error) =>
        error instanceof ApiError && error.status === 401 ? false : count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
